import axios from "axios";
import { API_URL } from "./ServiceAPI";

export const ReportAPI = {
  getReports: () => {
    return axios.get(`${API_URL}/Report/getReports`);
  },

  getPreviewVideoUrl: (id) => {
    return axios.get(`${API_URL}/Report/getPreviewVideoUrl/${id}`);
  },

  getHlsVideo: (id) => {
    return axios.get(`${API_URL}/Report/getVideo/${id}`);
  },

  getReportFile: (report_data_id, fileType = 0) => {
    return axios({
      url: `${API_URL}/Report/getReportFile/${report_data_id}/${fileType}`,
      method: "GET",
      responseType: "blob",
    });
  },

  getVideoDownloadLink: (report_id, setVideoReportProgress) => {
    return axios.get(`${API_URL}/Report/getDownloadVideoLink/${report_id}`, {
      responseType: "blob",
      onDownloadProgress: (event) => {
        if (event.total && setVideoReportProgress) {
          setVideoReportProgress((event.loaded / event.total) * 100);
        }
      },
    });
  },
};